<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.83398 3.33337L3.33398 5.83337L5.83398 8.33337" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round" />
        <path opacity="0.5"
            d="M3.33398 5.83337H12.5007C14.8018 5.83337 16.6673 7.69885 16.6673 10C16.6673 12.3012 14.8018 14.1667 12.5007 14.1667H6.66732"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    </svg>

</template>